import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";

export const DynamicBanner = props => {
  const { bannerUrl, cardImage, title, description } = props;

  const classes = styles();
  return (
    <div className={classes.relativeContainer}>
      <div
        style={{ backgroundImage: `url(${bannerUrl})` }}
        className={classes.bannerBackground}
      >
        <div className={classes.bannerDescriptionContainer}>
          <div className={classes.bannerDescription}>
            <div className={classes.bannerRectangle}></div>
            <div>
              <h1 className={classes.bannerTitle}>{title}</h1>
            </div>
            <div className={classes.bannersubTitle}> {description}</div>
          </div>
        </div>
      </div>
      <div className={classes.cardImage}>
        <img src={cardImage} alt={title} />
      </div>
    </div>
  );
};

DynamicBanner.propTypes = {
  bannerUrl: PropTypes.any.isRequired,
  cardImage: PropTypes.any.isRequired,
  title: PropTypes.any.isRequired,
  description: PropTypes.any.isRequired
};
